/**
 * @fileoverview Minimal toggleVariants for shadcn ToggleGroup, replacing registry import.
 * @module components/ui/toggle-variants
 */

import { cva, type VariantProps } from 'class-variance-authority'

export const toggleVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        default:
          'bg-secondary text-secondary-foreground hover:bg-secondary/80 data-[state=on]:bg-primary data-[state=on]:text-primary-foreground aria-[pressed=true]:bg-primary aria-[pressed=true]:text-primary-foreground aria-[checked=true]:bg-primary aria-[checked=true]:text-primary-foreground',
        outline:
          'border border-input bg-background hover:bg-accent hover:text-accent-foreground data-[state=on]:bg-accent data-[state=on]:text-accent-foreground aria-[pressed=true]:bg-accent aria-[pressed=true]:text-accent-foreground aria-[checked=true]:bg-accent aria-[checked=true]:text-accent-foreground',
      },
      size: {
        sm: 'h-8 px-2',
        default: 'h-9 px-3',
        lg: 'h-10 px-3',
      },
    },
    defaultVariants: {
      variant: 'outline',
      size: 'default',
    },
  }
)

export type ToggleVariants = VariantProps<typeof toggleVariants>
